import { SxProps } from '@mui/material';
import styles from './styles';

export const getBgStyles = (
  variant?:
    | 'base'
    | 'normalLeft'
    | 'normalLeftExtreme'
    | 'reverseLeft'
    | 'reverseCenter'
    | 'normalCenterAqua'
    | 'reverseCenterAqua'
    | 'normalCenterGreen'
    | 'alexanderHall'
    | 'redGradient'
) => {
  const bkImg: Record<string, SxProps> = {
    base: {
      ...styles.bkImgBase
    },
    normalLeft: {
      ...styles.bkImgNormalLeft
    },
    normalLeftExtreme: {
      ...styles.bkImgNormalLeftExtreme
    },
    reverseLeft: {
      ...styles.bkImgReverseLeft
    },
    reverseCenter: {
      ...styles.bkImgReverseCenter
    },
    normalCenterAqua: {
      ...styles.bkImgNormalCenterAqua
    },
    normalCenterGreen: {
      ...styles.bkImgNormalCenterGreen
    },
    reverseCenterAqua: {
      ...styles.bkImgReverseCenterAqua
    },
    alexanderHall: {
      ...styles.bkImgalexanderHall
    },
    redGradient: {
      ...styles.bkImgredGradient
    }
  };

  return {
    ...bkImg[variant]
  };
};

export const getLayoutTextStyles = (
  variant?:
    | 'base'
    | 'normalLeft'
    | 'normalLeftExtreme'
    | 'reverseLeft'
    | 'reverseCenter'
    | 'normalCenterAqua'
    | 'reverseCenterAqua'
    | 'normalCenterGreen'
    | 'alexanderHall'
    | 'redGradient'
) => {
  const layoutText: Record<string, SxProps> = {
    base: { ...styles.textContainer },
    normalLeft: { ...styles.textContainer },
    normalLeftExtreme: { ...styles.textContainer },
    reverseLeft: { ...styles.textContainerVariant },
    reverseCenter: { ...styles.textContainerVariant },
    normalCenterAqua: { ...styles.textContainer },
    reverseCenterAqua: { ...styles.textContainerVariant },
    normalCenterGreen: { ...styles.textContainerVariant },
    alexanderHall: { ...styles.textContainer },
    redGradient: { ...styles.textContainer }
  };

  return {
    ...layoutText[variant]
  };
};

export const getTitleTextStyles = (
  variant?:
    | 'base'
    | 'normalLeft'
    | 'normalLeftExtreme'
    | 'reverseLeft'
    | 'reverseCenter'
    | 'normalCenterAqua'
    | 'reverseCenterAqua'
    | 'normalCenterGreen'
    | 'alexanderHall'
    | 'redGradient'
) => {
  const titleText: Record<string, SxProps> = {
    base: { ...styles.title },
    normalLeft: { ...styles.title },
    normalLeftExtreme: { ...styles.title },
    reverseLeft: { ...styles.title },
    reverseCenter: { ...styles.title },
    normalCenterAqua: { ...styles.title },
    reverseCenterAqua: { ...styles.title },
    normalCenterGreen: { ...styles.titleVariant5 },
    alexanderHall: { ...styles.titleVariantBlack },
    redGradient: { ...styles.titleVariantBlack }
  };

  return {
    ...titleText[variant]
  };
};

export const getDescriptionStyles = (
  variant?:
    | 'base'
    | 'normalLeft'
    | 'normalLeftExtreme'
    | 'reverseLeft'
    | 'reverseCenter'
    | 'normalCenterAqua'
    | 'reverseCenterAqua'
    | 'normalCenterGreen'
    | 'alexanderHall'
    | 'redGradient'
) => {
  const titleText: Record<string, SxProps> = {
    base: { ...styles.description },
    normalLeft: { ...styles.description },
    normalLeftExtreme: { ...styles.description },
    reverseLeft: { ...styles.description },
    reverseCenter: { ...styles.description },
    normalCenterAqua: { ...styles.description },
    reverseCenterAqua: { ...styles.description },
    normalCenterGreen: { ...styles.descriptionVariant5 },
    alexanderHall: { ...styles.description },
    redGradient: { ...styles.description }
  };

  return {
    ...titleText[variant]
  };
};

export const getSubtitleStyles = (
  variant?:
    | 'base'
    | 'normalLeft'
    | 'normalLeftExtreme'
    | 'reverseLeft'
    | 'reverseCenter'
    | 'normalCenterAqua'
    | 'reverseCenterAqua'
    | 'normalCenterGreen'
    | 'alexanderHall'
    | 'redGradient'
) => {
  const subtitleText: Record<string, SxProps> = {
    base: { ...styles.subtitle },
    normalLeft: { ...styles.subtitle },
    normalLeftExtreme: { ...styles.subtitle },
    reverseLeft: { ...styles.subtitle },
    reverseCenter: { ...styles.subtitle },
    normalCenterAqua: { ...styles.subtitle },
    reverseCenterAqua: { ...styles.subtitle },
    normalCenterGreen: { ...styles.subtitleVariant5 },
    alexanderHall: { ...styles.subtitle },
    redGradient: { ...styles.subtitle }
  };

  return {
    ...subtitleText[variant]
  };
};

export const getBulletTextStyles = (
  variant?:
    | 'base'
    | 'normalLeft'
    | 'normalLeftExtreme'
    | 'reverseLeft'
    | 'reverseCenter'
    | 'normalCenterAqua'
    | 'reverseCenterAqua'
    | 'normalCenterGreen'
    | 'alexanderHall'
    | 'redGradient'
) => {
  const titleText: Record<string, SxProps> = {
    base: { ...styles.bulletTextStyle },
    normalLeft: { ...styles.bulletTextStyle },
    normalLeftExtreme: { ...styles.bulletTextStyle },
    reverseLeft: { ...styles.bulletTextStyle },
    reverseCenter: { ...styles.bulletTextStyle },
    normalCenterAqua: { ...styles.bulletTextStyle },
    reverseCenterAqua: { ...styles.bulletTextStyle },
    normalCenterGreen: { ...styles.bulletTextVariant5 },
    alexanderHall: { ...styles.bulletText },
    redGradient: { ...styles.bulletText }
  };

  return {
    ...titleText[variant]
  };
};
